import { IStoreState } from 'modules/types';
export const getLiveBreakoutGroupDetail = (state: IStoreState) => state.breakoutGroups?.liveBreakoutGroup;

export const getIfInBreakoutGroup = (state: IStoreState) =>
    state.breakoutGroups?.liveBreakoutGroup?.groupId && state.breakoutGroups?.liveBreakoutGroup?.isInBreakoutGroup;
export const getSelectedBreakoutGroupDetail = (state: IStoreState) => state.breakoutGroups?.selectedGroup;
